import type { EstimateStatus } from '@/types';

export const ESTIMATE_STATUS_COLORS: Record<EstimateStatus, { bg: string; text: string }> = {
  Draft: { bg: 'bg-gray-100', text: 'text-gray-600' },
  Sent: { bg: 'bg-blue-100', text: 'text-blue-700' },
  Converted: { bg: 'bg-green-100', text: 'text-green-700' },
  Expired: { bg: 'bg-red-100', text: 'text-red-700' },
};
